/* eslint-disable no-unused-vars */
import { Col, Input, List, Modal, Popover, Row, Tree } from "antd";
import React, { useState } from "react";

import "./TaskProperty.css";
import { NavLink } from "react-router-dom";
import { FolderOutlined, ProfileOutlined, RedEnvelopeOutlined, UserSwitchOutlined } from "@ant-design/icons";
import { TreeNode } from "antd/es/tree-select";

const list = [
  {
    itemType: "folder",
    icon: "fa-solid fa-folder",
    workNumber: 0,
    title: "Property Management Processes",
    color: "#687980",
  },
  {
    itemType: "folder",
    icon: "fa-solid fa-folder",
    workNumber: 0,
    title: "Admin Tasks",
    color: "#687980",
  },

];


function TaskProperty() {
  const [listData, setListData] = useState(list);



const [isModalVisible, setIsModalVisible] = useState(false);
const [folderName, setFolderName] = useState('');
const [selectedFolder, setSelectedFolder] = useState(null);
const handleOk = () => {
  setIsModalVisible(false);
};
const handleCancel = () => {
  setIsModalVisible(false);
 
};
const renderTreeNodes = (data) =>
  data.map((item) => (
    <TreeNode
      title={
        <span>
          <FolderOutlined style={{ marginRight: 8, color: 'black' }} />
          {item.title}
           <RedEnvelopeOutlined style={{ marginLeft: 8, color: 'gray' }} />
        </span>
      }
      key={item.key}
      icon={<FolderOutlined />}
      onClick={() => setSelectedFolder(item.key)}
      style={{
        margin: '7px 0px', fontSize: '13px',
        width: '100%', background: selectedFolder === item.key ? 'skyblue' : 'white',
        color: selectedFolder === item.key ? 'blue' : 'black'
      }}
    // className={selectedFolder === item.key ? 'hoverable' : 'hoverable1'}
    >
      {item.children && renderTreeNodes(item.children)}
    </TreeNode>
  ));
const folderData = [
  {
    key: '1',
    title: 'A. Property Management Processes',
  },
  {
    key: '2',
    title: 'B. Admin Tasks',
    children: [
    ],
  },
  {
    key: '3',
    title: 'C. Support Staff',
    children: [
    ],
  },

];


  let key;

  const CreateNewItem = (key) => {
    if (key === "folder") {
      setListData([
        ...listData,
        {
          itemType: "folder",
          icon: "fa-solid fa-folder",
          title: "untitled",
          color: "#687980",
        },
      ]);
    }
    if (key === "flow") {
      setListData([
        ...listData,
        {
          itemType: "workFlow",
          icon: "fa-brands fa-nfc-symbol",
          title: "untitled",
          color: "#645CBB",
        },
      ]);
    }
    if (key === "page") {
      setListData([
        ...listData,
        {
          itemType: "page",
          icon: "fa-solid fa-file-lines",
          title: "untitled",
          color: "#3b921e",
        },
      ]);
    }
  };

  const content = (
    <Row className="popover-container">
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow</strong>
            <p className="silver-text">Build a new workflow</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "flow"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-brands fa-nfc-symbol"
              style={{ color: "#645CBB" }}
            ></i>
          </Col>
          <Col>
            <strong>Workflow from Template</strong>
            <p className="silver-text">Explore our Template Gallery</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "page"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i
              className="fa-solid fa-file-lines"
              style={{ color: "#3b921e" }}
            ></i>
          </Col>
          <Col>
            <strong>Page</strong>
            <p className="silver-text">Document Team Knowledge</p>
          </Col>
        </Row>
      </Col>
      <Col
        span={24}
        className="add-col"
        onClick={() => CreateNewItem((key = "folder"))}
      >
        <Row gutter={[8, 0]}>
          <Col>
            <i className="fa-solid fa-folder" style={{ color: "#687980" }}></i>
          </Col>
          <Col>
            <strong>Folder</strong>
            <p className="silver-text">Organize Workflows and Pages</p>
          </Col>
        </Row>
      </Col>
    </Row>
  );
  return (
    <div className="task-property TaskProperty">
      <p className="right-title">
        <span>Library</span>
        <i className="fa-solid fa-gear" onClick={() => setIsModalVisible(true)} style={{cursor:'pointer'}}></i>
      </p>

      

      <List
        className="demo-loadmore-list"
        itemLayout="horizontal"
        dataSource={listData}
        renderItem={(item) => (
          <NavLink to={`/tasks/library/${item.title}`}>
            <List.Item
              actions={[
                <i
                  className={
                    item.itemType === "folder"
                      ? "fa-solid fa-gear"
                      : "fa-solid fa-ellipsis"
                  }
                ></i>,
                <i
                  className={
                    item.icon === "users"
                      ? "fa-solid fa-users"
                      : "fa-solid fa-building"
                  }
                ></i>,
                <i key="viewA" className="fa-solid fa-chart-bar"></i>,
                <i key="viewWF" className="fa-solid fa-table-list parent-work">
                  {item.workNumber > 0 ? (
                    <span className="child-work-number">{item.workNumber}</span>
                  ) : null}
                </i>,
              ]}
            >
              <Row gutter={[24, 0]} className="folder-title" align="middle">
                <Col>
                  <i
                    className={item.icon}
                    style={{
                      fontSize: "18px",
                      color: item.color,
                    }}
                  ></i>
                </Col>
                <Col>
                  <span style={{ fontSize: "17px" }}>{item.title}</span>
                </Col>
              </Row>
            </List.Item>
          </NavLink>
        )}
      />
      <Popover
        placement="topLeft"
        title="Create"
        content={content}
        trigger="click"
      >
        <Row gutter={[16, 0]} className="add-new">
          <Col>
            <i className="fa-solid fa-plus"></i>
          </Col>
          <Col>
            <span>New</span>
          </Col>
        </Row>
      </Popover>


      <Modal
        title="Create Folder"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Create"
      >
        <Row gutter={[0, 20]}>
          <Col span={24}>
            <p style={{ margin: '15px 0px 8px 0px' }}>Name</p>
            <Input
              value={folderName}
              onChange={(e) => setFolderName(e.target.value)}
              placeholder="Folder name"
            />
          </Col>
          <Col span={24} >
            <p style={{ margin: '10px 0px 8px 0px' }}>Location</p>
            <Col style={{ display: 'flex' }} className='hoverable'>
              <Col span={2} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}><UserSwitchOutlined /></Col>
              <Col span={22}>
                <div>Private Library</div>
                <div style={{ color: 'gray', fontSize: '12px' }}>Only you will be able to view this.</div>
              </Col>
            </Col>
          </Col>
          <hr style={{ width: '100%', border: '1px solid lightgray', transform: 'scaleY(0.1)', opacity: '0.7' }} />
          <Col span={24} style={{ display: 'flex' }} className="hoverable">
            <Col span={2} style={{ display: 'flex', justifyContent: 'start', alignItems: 'center' }}><ProfileOutlined /></Col>
            <Col span={22}>
              <div>Interity Oklahoma LLC</div>
            </Col>
          </Col>
          <Col span={24}>
            <Tree defaultExpandAll> {renderTreeNodes(folderData)}</Tree>
          </Col>
        </Row>
      </Modal>
    </div>
  );
}

export default TaskProperty;
